import { render } from "./TopBar.vue?vue&type=template&id=fa20092c"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"
script.render = render

export default script